export const HEADER_HEIGHT = 59;
